import { useSite } from '@edreamsodigeo/frontend-core';
import { isEqualProminenceMobileBySite } from 'clientState/properties/EqualProminenceMobileSiteProperties';
import { usePrime } from 'clientState/providers/PrimeProvider';
import { useFlowTools } from 'flowTools/useFlowTools';

export const useEqualProminencePrimeDisplayMobile = () => {
  const { isPrimeSite, isLoggedPrimeUser } = usePrime() || {};
  const { isMobile } = useFlowTools();
  const site = useSite();
  return (
    isEqualProminenceMobileBySite(site) &&
    isMobile &&
    isPrimeSite &&
    !isLoggedPrimeUser
  );
};
